module.exports = __webpack_public_path__ + "media/images/cruze-logo-small-yellow-f60c3ff2988a15e7eb1a79359f18ce35.png";